<template>

    <van-form ref="additionalInformation" style="padding-bottom: .1rem">
        <van-row class="field-title">合同号</van-row>
        <van-field v-model="originCertificate.contractNum"></van-field>

        <van-row class="field-title">FOB金额(美元)</van-row>
        <van-field v-model="originCertificate.fobAmount"></van-field>

        <van-row class="field-title">付款方式</van-row>
        <van-field v-model="originCertificate.payTerm"></van-field>

        <van-row class="field-title">贸易方式</van-row>
        <van-field v-model="originCertificate.tradeModel"></van-field>

        <van-row class="field-title">手签员(Authorised signatory)</van-row>
        <van-field v-model="originCertificate.handSigner"></van-field>

        <van-row class="field-title">信用证号</van-row>
        <van-field v-model="originCertificate.creditNum"></van-field>

        <van-row class="field-title">信用证开证日期</van-row>
        <van-field v-model="originCertificate.certificateTime"></van-field>

        <van-row class="field-title">报关单号</van-row>
        <van-field v-model="originCertificate.declarationNum"></van-field>

        <van-row class="field-title">出境海关</van-row>
        <van-field v-model="originCertificate.customsId"></van-field>

        <van-row class="field-title">企业海关编码</van-row>
        <van-field v-model="originCertificate.customsNum"></van-field>

        <van-row v-if="'REGION_CODE_15' != region.value" class="field-title">eCO打印副本数</van-row>
        <van-field v-if="'REGION_CODE_15' != region.value" v-model="originCertificate.printNum"></van-field>

<!--        <van-row class="field-title">印章、签名选项</van-row>-->
<!--        <van-field v-model="originCertificate.signItem"></van-field>-->
    </van-form>


</template>

<script>
    export default {
        name: "PrefAdditionalInformationView",
        props: {
            region: Object,
            viewedOriginCertificate: Object,
        },
        data() {
            return {
                originCertificate: Object.assign({}, this.viewedOriginCertificate),

            }
        },
        created() {

        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep {
        .field-title {
            padding: 13px 16px 0 24px !important;

            &:after {
                display: none;
            }

            .van-cell__value {
                color: #969799;
            }
        }

        .van-cell.van-field {
            padding: 13px 16px 0 24px !important;
        }
    }
</style>
